import { ANALYTICS_CONTEXT } from '@peloton/analytics/baseProperties';
import { toClient } from '@peloton/api/client';
import { CLIENT_CONTEXT as API_CLIENT } from '@peloton/api/utils';
import type { ErrorHandler } from '@peloton/error-reporting';
import { CLIENT_CONTEXT as ERROR_REPORTING_CLIENT_CONTEXT } from '@peloton/error-reporting/sagas';
import { EXT_LINK_ENV_CONTEXT } from '@peloton/external-links/constants';
import toStore from '@peloton/redux/toStore';
import { toWebBaseProperties } from '@members/analytics/webBaseProperties';
import { toStoreReducers } from '@members/bootstrapping/redux';
import { toStoreSagas } from '@members/bootstrapping/sagas/toStoreSagas';
import createPersistentStore, {
  toPersistentRootReducer,
} from '@members/persist/createPersistentStore';

export const generateStore = ({
  env,
  errorHandler,
}: {
  env: any;
  errorHandler: ErrorHandler;
}) => {
  const client = toClient({
    env: env.extLink,
    withCredentials: false,
    acceptLanguageEnabled: true,
  });

  const store = toStore({
    initialState: {
      extLinkEnv: env.extLink,
    },

    reducers: toStoreReducers(),
    sagas: toStoreSagas(),

    context: {
      [API_CLIENT]: client,
      [ERROR_REPORTING_CLIENT_CONTEXT]: errorHandler.reportError,
      [EXT_LINK_ENV_CONTEXT]: env.extLink,
      [ANALYTICS_CONTEXT]: toWebBaseProperties(),
    },
    onError: errorHandler.sagaOnError,

    rootReducer: toPersistentRootReducer,

    createStore: createPersistentStore,
  });

  return { client, store };
};
